import React, { PropsWithChildren } from 'react'
import { Button, Icon, Modal } from '@afterpaytouch/core'
import { useTranslation } from 'next-i18next'

interface OrderSupportModalHeaderProps {
  onClose: () => void
  onBack?: () => void
}

export const OrderSupportModalHeader = ({ children, onClose, onBack }: PropsWithChildren<OrderSupportModalHeaderProps>) => {
  const { t } = useTranslation('common')

  return (
    <Modal.Header divider>
      <div className='grid grid-cols-[24px_minmax(0,1fr)_24px] items-center gap-2'>
        <div>
          {onBack && (
            <Button.Link size='Small' onClick={onBack} aria-label={t('common:back')}>
              <Icon.CaretLeft size='Small' />
            </Button.Link>
          )}
        </div>
        <div className='text-center'>{children}</div>
        <Button.Link size='Small' onClick={onClose} aria-label={t('common:close')}>
          <Icon.Close size='Small' />
        </Button.Link>
      </div>
    </Modal.Header>
  )
}
